export default __webpack_public_path__ + "static/media/filter.99f052d5.svg";